import React from 'react';

const StatsCard = ({
  title,
  subtitle,
  value,
  icon: Icon,
  color = 'blue',
  change,
  changeType = 'positive',
  onClick
}) => {
  const badgeColors = {
    blue: "bg-blue-50 text-blue-600",
    red: "bg-rose-50 text-rose-600",
    purple: "bg-purple-50 text-purple-600",
    cyan: "bg-cyan-50 text-cyan-600",
    green: "bg-emerald-50 text-emerald-600",
    teal: "bg-teal-50 text-teal-600",
    amber: "bg-amber-50 text-amber-600",
    orange: "bg-orange-50 text-orange-600",
    indigo: "bg-indigo-50 text-indigo-600",
  };

  const selectedBadge = badgeColors[color] || badgeColors.blue;

  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-2xl p-3.5 sm:p-4 border border-slate-100 shadow-2xs hover:shadow-md transition-all duration-200 flex items-center gap-3.5 ${onClick ? 'cursor-pointer' : ''}`}
    >
      {Icon && (
        <div className={`w-9 h-9 rounded-full ${selectedBadge} flex items-center justify-center shrink-0 shadow-2xs`}>
          <Icon className="w-4.5 h-4.5" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <h3 className="text-xs font-semibold text-slate-500 truncate tracking-wide">
          {title}
        </h3>
        <div className="flex items-baseline gap-2 mt-0.5">
          <span className="text-xl sm:text-2xl font-bold text-slate-900 leading-none">
            {value}
          </span>
          {subtitle && (
            <span className="text-[11px] font-medium text-slate-400 truncate">
              {subtitle}
            </span>
          )}
        </div>
        {change && (
          <span className={`text-[10px] font-bold mt-1 block ${changeType === 'positive' ? 'text-emerald-600' : 'text-rose-500'}`}>
            {change}
          </span>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
